import { Form, TimePicker } from "antd";
import moment from "moment-business-days";
import { useRef } from "react";
import K from "utilities/constants";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFTimePicker({
  title = "Title",
  isFormItem = true,
  className,
  placeholder = "",
  formItemName = "",
  required = true,
  params,
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const dateRef = useRef(null);
  const onChange = (dateObj) => {
    dateRef.current = dateObj ? dateObj.format(K.TimeFomat.Response) : null;
  };

  const renderField = () => (
    <TimePicker
      {...params}
      format={K.TimeFomat.Display}
      className=""
      onChange={onChange}
      placeholder={placeholder}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        initialValue={moment()}
        rules={required && [{ required: true, message: `Enter  ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
